import { render, staticRenderFns } from "./WolfCard.vue?vue&type=template&id=6fc80392&scoped=true&"
import script from "./WolfCard.vue?vue&type=script&lang=js&"
export * from "./WolfCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc80392",
  null
  
)

export default component.exports